const pageURL = {
  home: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  userManagement: '/user-management',
  supplierAccountManagement: '/supplier-account-management',
  moduleManagement: '/module-management',
  pif: '/pif',
  suppliersOpening: '/supplier-registration',
  health: '/health',
  barcodeUpload: '/pif/barcode-upload',
  barcodeSupplierSend: '/pif/supplier-barcode-send',
  barcodeSendApproval: '/pif/barcode-send-approval',
  barcodeApproveOrReject: '/pif/barcode-approve-or-reject',
  changeUser: '/change-user',
  documentTypeManagement: '/document-type-management',
  currentTypeManagement: '/supplier-type-management',
  dataEntyControl: '/data-entry-control',
  currentAccountOpeningManagerControl: '/current-account-opening-manager-control',
  currentAccountOpeningHeadControl: '/current-account-opening-head-control',
  companyDocumentManagement: '/supplier-document-management',
  currentAccountOpeningDashboard: '/supplier-registration-dashboard',
  currentAccountOpeningAuditControl: '/supplier-registration-audit-control',
  currenAccountOpenningAprrovalControl: '/supplier-registration-approval-control',
  kkdikDashboard: '/kkdik/dashboard',
  kkdikProducts: '/kkdik/products',
  kkdikChemicalSubstance: '/kkdik/chemical-substance',
  kkdikChemicalContent: '/kkdik/chemical-content',
  supplierProductDetailInformationManagement: '/supplier-product-detail-information-management',
  productDetailInformationManagement: '/product-detail-information-management',
  roleManagement: '/role-management',
  permissionManagement: '/role-management/roles',
  userRoleManagement: '/role-management/user-roles',
  groupManagement: '/role-management/group-roles',
  contractManagement: '/contract-management',
  contracts: '/contract-management/contracts',
  createContract: '/contract-management/create-contract',
  copyContract: '/contract-management/copy-contract',
  editContract: '/contract-management/edit-contract',
  categoryManagement: '/category-management',
  promotion: '/promotion',
  promotionDefinition: '/promotion/definition',
  promotionCreate: '/promotion/definition/create',
  promotionEdit: '/promotion/definition/edit',
  promotionView: '/promotion/definition/view',
  promotionManagement: '/promotion/management',
  promotionManagementEdit: '/promotion/management/edit',
  promotionManagementSuppliers: '/promotion/management/suppliers',
  promotionEvaluation: '/promotion/management/evaluation',
  promotionSupplierSupport: '/promotion/supplier-support',
  promotionSupplierSupportEntry: '/promotion/supplier-support/entry',
  promotionSupportProcessing: '/promotion/support-processing',
  promotionFinalSupportValues: '/promotion/support-processing/final-values'
};

export default pageURL;
